import createCache from '@emotion/cache'

// Stylis runs plugins BEFORE stringify sets element.return, so we must build
// the CSS string ourselves from the parsed element tree and set element.return
// to short-circuit stringify. This wraps every MUI rule in @layer mui so that
// Tailwind v4's @layer utilities (declared later in globals.css) always wins.
const muiLayerPlugin = (element: any) => {
  if (element.type !== 'rule') return
  if (element.parent?.type === '@keyframes') return

  const selectors = (Array.isArray(element.props) ? element.props : [element.value]).join(',')
  const declarations = (element.children ?? [])
    .filter((c: any) => c.type === 'decl')
    .map((c: any) => `${c.props}:${c.value}`)
    .join(';')

  if (selectors && declarations) {
    element.return = `@layer mui{${selectors}{${declarations}}}`
  }
}

export default function createEmotionCache() {
  return createCache({
    key: 'css',
    prepend: true,
    stylisPlugins: [muiLayerPlugin],
  })
}
